import { render } from "./index.vue?vue&type=template&id=1ee9d4a6&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=1ee9d4a6&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-1ee9d4a6"

export default script